export default "__VITE_ASSET__DWUjUjMc__"